import type { ReactNode } from 'react';
import { Info, TriangleAlert } from 'lucide-react';
import { cx } from '../../lib/util/cx';

/**
 * Port of the kit's AdminChrome `DocNote`: the note at the top of a screen.
 * `info` is the blue explainer; `mock` is the amber "mocked in this build"
 * banner (FE plan §4.2). Values copied from the kit, not approximated.
 */
const TONE = {
  info: { box: 'bg-[rgba(127,150,254,.12)] border-[rgba(127,150,254,.3)]', icon: 'text-[#223679]', Icon: Info },
  mock: { box: 'bg-[rgba(180,158,49,.14)] border-[rgba(180,158,49,.34)]', icon: 'text-[#7A5A12]', Icon: TriangleAlert },
} as const;

export function DocNote({
  tone = 'info',
  children,
  className,
}: {
  tone?: keyof typeof TONE;
  children: ReactNode;
  className?: string;
}) {
  const t = TONE[tone];
  return (
    <div
      className={cx(
        'mb-4 flex items-start gap-2.5 rounded-[10px] border px-[15px] py-3 text-[13px] leading-[1.55] text-ink',
        t.box,
        className,
      )}
    >
      <span className={cx('mt-px inline-flex shrink-0', t.icon)}>
        <t.Icon size={16} strokeWidth={2} aria-hidden="true" />
      </span>
      <span>{children}</span>
    </div>
  );
}
